class TyeMobileNavigation extends HTMLElement {
  connectedCallback() {
    this.menuTrigger = this.querySelector('[data-tye-menu-trigger]');
    this.menuDetails = document.querySelector('#Details-menu-drawer-container');

    this.onMenuClick = this.onMenuClick.bind(this);
    this.syncMenuState = this.syncMenuState.bind(this);
    this.onViewportResize = this.onViewportResize.bind(this);

    this.menuTrigger?.addEventListener('click', this.onMenuClick);

    if (this.menuDetails) {
      this.menuObserver = new MutationObserver(this.syncMenuState);
      this.menuObserver.observe(this.menuDetails, { attributes: true, attributeFilter: ['open'] });
      this.syncMenuState();
    }

    if (window.visualViewport) {
      this.baselineViewportHeight = window.visualViewport.height;
      window.visualViewport.addEventListener('resize', this.onViewportResize, { passive: true });
      window.addEventListener('orientationchange', this.resetViewportBaseline, { passive: true });
    }

    this.setupStickyAddToCartIntegration();
  }

  disconnectedCallback() {
    this.menuTrigger?.removeEventListener('click', this.onMenuClick);
    this.menuObserver?.disconnect();
    this.stickyBuyButtonsObserver?.disconnect();
    this.stickyFooterObserver?.disconnect();
    this.stickyStateObserver?.disconnect();
    window.visualViewport?.removeEventListener('resize', this.onViewportResize);
    window.removeEventListener('orientationchange', this.resetViewportBaseline);
  }

  onMenuClick() {
    const nativeSummary = this.menuDetails?.querySelector(':scope > summary');
    nativeSummary?.click();
  }

  syncMenuState() {
    const isOpen = Boolean(this.menuDetails?.open);
    this.menuTrigger?.setAttribute('aria-expanded', String(isOpen));

    if (isOpen) {
      this.menuTrigger?.setAttribute('data-open', 'true');
    } else {
      this.menuTrigger?.removeAttribute('data-open');
    }
  }

  onViewportResize() {
    if (!window.visualViewport || !this.baselineViewportHeight) return;

    const currentHeight = window.visualViewport.height;
    const keyboardLikelyOpen = currentHeight < this.baselineViewportHeight * 0.72;

    if (keyboardLikelyOpen) {
      this.setAttribute('data-keyboard-open', '');
    } else {
      this.removeAttribute('data-keyboard-open');
      if (currentHeight > this.baselineViewportHeight) this.baselineViewportHeight = currentHeight;
    }
  }

  setupStickyAddToCartIntegration() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;

    const stickyAddToCart = document.querySelector('sticky-add-to-cart');
    if (!stickyAddToCart) return;

    const stickyBar = stickyAddToCart.querySelector('[ref="stickyBar"]');
    const productSection = stickyAddToCart.closest('.shopify-section');
    const buyButtons = productSection?.querySelector('.buy-buttons-block');
    const footer = document.querySelector('footer') ?? document.querySelector('[class*="footer-group"]');
    if (!stickyBar || !buyButtons || !footer) return;

    let buyButtonsPassed = false;
    let footerNear = false;

    const syncStickyState = () => {
      const shouldShow = buyButtonsPassed && !footerNear && stickyAddToCart.dataset.variantAvailable === 'true';
      const nextState = shouldShow ? 'true' : 'false';
      if (stickyBar.dataset.stuck !== nextState) stickyBar.dataset.stuck = nextState;
    };

    this.stickyBuyButtonsObserver = new IntersectionObserver((entries) => {
      const entry = entries[0];
      if (!entry) return;
      const rect = entry.target.getBoundingClientRect();
      buyButtonsPassed = !entry.isIntersecting && (rect.bottom < 0 || rect.top < 0);
      syncStickyState();
    });

    this.stickyFooterObserver = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (!entry) return;
        footerNear = entry.isIntersecting;
        syncStickyState();
      },
      { rootMargin: '200px 0px 0px 0px' }
    );

    this.stickyStateObserver = new MutationObserver(() => {
      if (buyButtonsPassed && !footerNear && stickyAddToCart.dataset.variantAvailable === 'true') {
        if (stickyBar.dataset.stuck !== 'true') stickyBar.dataset.stuck = 'true';
      }
    });

    this.stickyBuyButtonsObserver.observe(buyButtons);
    this.stickyFooterObserver.observe(footer);
    this.stickyStateObserver.observe(stickyBar, { attributes: true, attributeFilter: ['data-stuck'] });
  }

  resetViewportBaseline = () => {
    window.setTimeout(() => {
      if (window.visualViewport) this.baselineViewportHeight = window.visualViewport.height;
      this.removeAttribute('data-keyboard-open');
    }, 250);
  };
}

if (!customElements.get('tye-mobile-navigation')) {
  customElements.define('tye-mobile-navigation', TyeMobileNavigation);
}
